module.exports = __webpack_public_path__ + "static/img/h4.a3ac649.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/h4.gif
// module id = EJjI
// module chunks = 1